"use strict";
exports.__esModule = true;
var AbstractRegistry = (function () {
    function AbstractRegistry(description) {
        this.SERIAL_VERSION_UID = 'd8a5aa78-978e-11e6-ae22-56b6b6499611';
        this.description = description;
    }
    return AbstractRegistry;
}());
exports["default"] = AbstractRegistry;
//# sourceMappingURL=AbstractRegistry.js.map